<template>
  <header class="header d-flex flex-column align-items-start justify-content-between" style="width: 100%; padding: 20px">
    <div class="d-flex align-items-center justify-content-between" style="width: 100%;">
      <img :src="HeaderLogo" alt="CreateLogo" class="create-logo" style="height:30px;"/>
    </div>
    <nav class="d-flex align-items-center justify-content-between" style="width: 100%; margin-top:20px">
      <button 
        class="nav-item" 
        style="padding-left:10px; padding-right:10px; height:40px; width:auto; margin-right:20px; border: 2px solid #38b6ff; border-radius: 10px; background: none; color: #38b6ff; cursor: pointer;" 
        @click="$router.push({ name: 'CreditsHistory', params: { id: userId } })">
        Créditos: {{ credits }}
      </button>
    </nav>
  </header>
    <div class="container" style="height: 100vh;">
      <div class="card-container" style="display: flex; justify-content: center; align-items: center;">
      <div class="card" style="width: 100%; height: 100%;">
      <div class="card-body">
        <h1 class="card-title" style="margin-top: 20px;">Tu suscripcion ha sido activada exitosamente!</h1>
            <p>Ahora podras darle a tu piel la atencion que necesita durante todo el año</p>
        <router-link to="/patient-dashboard" class="btn btn-primary" style="margin-top: 20px;">Regresar</router-link>
      </div>
    </div>
  </div>
    </div>
    
</template>

<script>
  import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { mapActions, mapState } from 'vuex';
import useFacebookPixel from '@/composables/useFacebookPixel';

  import axios from 'axios';
  import { onMounted } from 'vue';


export default {
  setup() {
    const { track } = useFacebookPixel();

    onMounted(() => {
      track('ViewContent', {content_name: 'Subscription Success' });
      track('Subscribe', { value: 75.00, currency: 'MXN', content_name: 'Subscription Success' });

      
    });

    return {};
  }, 
  data() {
    return {
      nextChargeDate: '',
      HeaderLogo: require('@/assets/dermapp-white.png')
    };
  },
  computed: {
    ...mapState(['email', 'userId', 'isSubscribed', 'credits', 'country', 'phone', 'referralCode', 'profileId', 'profileSex', 'primaryName', 'primaryBirthday']),
    },
  mounted() {
    const auth = getAuth();
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          // Refrescar el token
          const idToken = await user.getIdToken(true); // El 'true' fuerza a refrescar el token

          // Actualizar localStorage con el nuevo token
          localStorage.setItem('Token', idToken);
          localStorage.setItem('Email', user.email);
          const token = localStorage.getItem('Token');
    axios.get(`${this.$baseURL}/api/user-data-v2`, {
      params: {
        email: this.email || this.$route.query.email,
        page: 'Subscription Success'
      },
      headers: {
          'Authorization': `Bearer ${token}`
        }
    })
    .then((response) => {
      const data = response.data.data;
      this.updateUserId(data.id);
      this.updateEmail(data.email);
      this.updatePhone(data.phone, data.country);
      this.updateCountry(data.country);
      this.updateCredits(data.credits);
      this.updateReferralCode(data.referral_code);
      
    })
    .catch((error) => {
      console.error("Error fetching user data:", error);
    });
        } catch (error) {
          console.error('Error al renovar el token:', error);

          // Si el token está expirado o hay un error de autenticación
          if (error.code === 'auth/id-token-expired' || error.code === 'auth/user-token-expired' || error.message.includes('Token')) {
            localStorage.removeItem('Token'); // Limpiar el token expirado
            this.$router.push('/SignIn'); // Redirigir al login
          }
        }
      } else {
        // Si no hay un usuario autenticado, redirigir al login
        this.$router.push('/SignIn'); // Redirigir al login
      }
    });

  },
  methods: {
    ...mapActions(['updateUserId', 'updateEmail', 'updatePhone', 'updateCountry', 'updateCredits', 'updateReferralCode', 'updateProfileId', 'updateProfileName', 'updateProfileSex', 'updateProfileSubscription',  ]),
  },
};
</script>

<style scoped>

.header {
  margin-top: -5px;
  position: relative;
  width: 100%;
  height: auto;
  background: #36b5ff;
  z-index: 1;
}

.nav-item {
margin-right: 20px;
background: none;
border: none;
color: white;
cursor: pointer;
}

</style>